import Head from 'next/head'
import { useRouter } from 'next/router'
import styled from 'styled-components'

import ViewListingCard from 'modules/ListingCards/ViewListingCard'
import PageStepper from 'modules/PageStepper'

import Breadcrumbs from 'components/Breadcrumbs'
import ErrorBox from 'components/ErrorBox'
import ExtraLargeHeader from 'components/ExtraLargeHeader'
import GridContainer from 'components/GlobalStyles/GridContainer'
import Spacer from 'components/Spacer'

import { useRecentlySoldListingsOld } from 'services/swr/listings/useRecentlySoldListings'

import { BreadcrumbEnum } from 'types/enums'

const MaxWidthContainer = styled.div`
  margin: 0 auto;
  max-width: ${props => props.theme.metrics.maxGridWidth}px;
  padding: 0 ${props => props.theme.metrics.gutterPhone}px;
`

const CenteredContainer = styled.div`
  display: flex;
  justify-content: center;
`

const PER_PAGE = 24

const SoldListings = () => {
  const router = useRouter()

  const {
    query: { page },
  } = router

  const { recentlySoldListings, count, error } = useRecentlySoldListingsOld({
    limit: PER_PAGE,
    skip: PER_PAGE * ((Number(page as string) || 1) - 1),
  })

  const displayListings = recentlySoldListings || []

  return (
    <MaxWidthContainer>
      <Head>
        <title>Just Sold and Completed Home Sales - HomeLister</title>
        <meta
          name="description"
          content="See just sold and completed home sale listings at HomeLister."
        />
        <meta
          name="keywords"
          content="Just Sold, Completed Home Sales, HomeLister"
        />
      </Head>
      <ExtraLargeHeader
        title="Recent Sales"
        headerThree
      />
      <Breadcrumbs
        name={BreadcrumbEnum.RecentSales}
        noMargin
      />
      <Spacer size={18} />
      {error && (
        <>
          <ErrorBox error="There was a problem loading listings. Please try again." />
          <Spacer size={18} />
        </>
      )}
      <GridContainer
        desktopGridGap={30}
        desktopCols={3}
        largeDesktopCols={3}
        desktopMaxWidth={555}
      >
        {displayListings.map(listing => (
          <ViewListingCard
            key={listing._id}
            listing={listing}
            infoHeight={130}
            soldListing
          />
        ))}
      </GridContainer>
      <Spacer size={50} />
      <CenteredContainer>
        <PageStepper
          currentPage={page ? Number(page) : 1}
          pageSize={PER_PAGE}
          totalItems={count}
          pathname="/listings/sold"
        />
      </CenteredContainer>
      <Spacer size={100} />
    </MaxWidthContainer>
  )
}

export default SoldListings
